import Iconify, { type IconifyProps } from 'components/Iconify';

type Props = Omit<IconifyProps, 'icon'>;

export const ChevronDownIcon = (props: Props) => {
  return <Iconify icon="eva:arrow-ios-downward-fill" {...props} />;
};
